import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=a26c3ac0&scoped=true"
import script from "./EditorWrapper.vue?vue&type=script&lang=js"
export * from "./EditorWrapper.vue?vue&type=script&lang=js"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=a26c3ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26c3ac0",
  null
  
)

export default component.exports